import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { SnackbarProvider } from "notistack";

import store from "./store/index";
import { Provider } from "react-redux";
import ContextProvider from "./context/Context";

const clearLegacyServiceWorkerCaches = async () => {
  try {
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }

    if ("caches" in window) {
      const cacheKeys = await caches.keys();
      await Promise.all(cacheKeys.map((key) => caches.delete(key)));
    }
  } catch (error) {
    console.warn("Failed to clear legacy service worker caches:", error);
  }
};

ReactDOM.render(
  <SnackbarProvider maxSnack={3}>
    <ContextProvider>
      <App />
    </ContextProvider>
  </SnackbarProvider>,
  document.getElementById("root")
);

// document.addEventListener('contextmenu', function(e) {
//   e.preventDefault();
// });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
clearLegacyServiceWorkerCaches().finally(() => {
  serviceWorker.unregister();
});
